var fullscreenVideo = {
    selector: '[data-video-yt]',
    init: function() {
        var self = this,
            $videos = $( self.selector );

        if ( $videos.length < 1 ) {
            return;
        }

        var tag = document.createElement( 'script' );

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
        firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

        $( document.body ).on( 'youtube', function() {
            $videos.each( function() {
                var video    = this,
                    $video   = $( this ),
                    $wrapper = $video.parent( '[data-video-wrapper]' ),
                    player   = new YT.Player( video, {
                        host: 'https://www.youtube-nocookie.com',
                        height: '100%',
                        width: '100%',
                        videoId: video.getAttribute( 'data-video-yt' ),
                        playerVars: {
                            rel: 0,
                            modestbranding: 1
                        },
                        events: {
                            'onReady': self.onPlayerReady,
                            'onStateChange': self.onPlayerStateChange
                        }
                    } );

                var id = $video.attr( 'data-video-id' );

                $( '[data-video-trigger="' + id + '"]' ).on( 'click', function(e) {
                    e.preventDefault();

                    $wrapper.addClass( 'active' );
                    player.playVideo();
                } );

                $( '[data-video-close="' + id + '"]' ).on( 'click', function(e) {
                    e.preventDefault();

                    $wrapper.removeClass( 'active' );
                    player.stopVideo();
                } );
            } );
        } );
    },
    onPlayerReady: function( e ) {
        console.log( e );
    },
    onPlayerStateChange: function( e ) {
        console.log( e );
    }
};

export {
    fullscreenVideo
};
